import { render, staticRenderFns } from "./ChartAbsent.vue?vue&type=template&id=35bee00f&scoped=true&"
import script from "./ChartAbsent.vue?vue&type=script&lang=js&"
export * from "./ChartAbsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bee00f",
  null
  
)

export default component.exports